import {Injectable, EventEmitter} from '@angular/core';
import {CourierResponse, AvailableCourierResponse, AvailableCourierDatesResponse} from './classes/courier.model';
import {PageContent} from './classes/page-content.model';
import {Merchant} from './classes/merchant.model';
import {FormGroup} from '@angular/forms';
import {FirstTabComponent} from '../tabs/first-tab/first-tab.component';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable()
export class RightSideService {
  merchantChange: EventEmitter<number> = new EventEmitter<number>();
  labelChange: EventEmitter<string> = new EventEmitter<string>();
  topImageUrlChange: EventEmitter<string> = new EventEmitter<string>();
  imageUrlChange: EventEmitter<string> = new EventEmitter<string>();
  categoryNameChange: EventEmitter<string> = new EventEmitter<string>();
  resetChangesEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedCategoryId: number;
  cashbackEnabled: boolean;
  cashbackEnabledChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  cashbackSelected = false;
  selectedProductId: number;
  merchant: Merchant = new Merchant();
  label: string;
  categoryName: string;
  topImageUrl: string;
  imageUrl: string;
  deci: number;
  courier: CourierResponse;
  availableCourier: AvailableCourierResponse;
  availableCourierDates: AvailableCourierDatesResponse;
  resetChanges: boolean;
  pageContentChange: EventEmitter<PageContent> = new EventEmitter<PageContent>();
  pageContent: PageContent;
  isForwarded = false;
  firstForm: FormGroup;
  isResultViewed = false;
  firstTab: FirstTabComponent;
  isRedirected = false;
  isAuth = false;
  isAuthChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  shopperId: string;
  shopperIdChange: EventEmitter<string> = new EventEmitter<string>();
  shopperEmail: string;
  shopperEmailChange: EventEmitter<string> = new EventEmitter<string>();
  isAuthWarning = false;
  brandName: string;
  modelName: string;
  topHeight: any;

  constructor(
    private sanitizer: DomSanitizer,
  ) {
  }

  setIsAuthWarning(isAuthWarning) {
    this.isAuthWarning = isAuthWarning;
  }

  getIsAuthWarning() {
    return this.isAuthWarning;
  }

  setSelectedCategoryId(categoryId) {
    this.selectedCategoryId = categoryId;
  }

  getSelectedCategoryId() {
    return this.selectedCategoryId;
  }

  setIsAuth(isAuth) {
    this.isAuth = isAuth;
    this.isAuthChange.emit(this.isAuth);
  }

  getIsAuth() {
    return this.isAuth;
  }

  setIsRedirected(isRedirected) {
    this.isRedirected = isRedirected;
  }

  getIsRedirected() {
    return this.isRedirected;
  }

  setShopperId(shopperId) {
    this.shopperId = shopperId;
    this.shopperIdChange.emit(this.shopperId);
  }

  getShopperId() {
    return this.shopperId;
  }

  setShopperEmail(shopperEmail) {
    this.shopperEmail = shopperEmail;
    this.shopperEmailChange.emit(this.shopperEmail);
  }

  getShopperEmail() {
    return this.shopperEmail;
  }

  setMerchantInfo(merchant) {
    this.merchant = merchant;
    this.merchantChange.emit(merchant);
  }

  getMerchantInfo() {
    return this.merchant;
  }

  setPrice(price) {
    this.setMerchantInfo({
      ...this.merchant,
      price: price,
    });
  }

  getPrice() {
    return this.merchant.price;
  }

  setResetChanged(isChanged) {
    this.resetChanges = isChanged;
    this.resetChangesEvent.emit(this.resetChanges);
  }

  getResetChanged() {
    return this.resetChanges;
  }

  setPageContent(pageContent: PageContent) {
    this.pageContent = pageContent;
    this.pageContentChange.emit(this.pageContent);
  }

  getPageContent() {
    return this.pageContent;
  }

  setCategoryName(categoryName) {
    this.categoryName = categoryName;
    this.categoryNameChange.emit(this.categoryName);
  }

  getCategoryName() {
    return this.categoryName;
  }

  setTopImageUrl(imageUrl) {
    this.topImageUrl = imageUrl;
    this.topImageUrlChange.emit(this.topImageUrl);
  }

  getTopImageUrl() {
    return this.topImageUrl;
  }

  setImageUrl(imageUrl) {
    this.imageUrl = imageUrl;
    this.imageUrlChange.emit(this.imageUrl);
  }

  getImageUrl() {
    return this.imageUrl;
  }

  setDeci(deci) {
    this.deci = deci;
  }

  getDeci() {
    return this.deci;
  }

  setCashbackEnabled(isCashbackEnabled) {
    this.cashbackEnabled = isCashbackEnabled;
    this.cashbackEnabledChange.emit(this.cashbackEnabled);
  }

  getCashbackEnabled() {
    return this.cashbackEnabled;
  }

  setCashbackSelected(isCashbackSelected) {
    this.cashbackSelected = isCashbackSelected;
  }

  getCashbackSelected() {
    return this.cashbackSelected;
  }

  setCourier(courier) {
    this.courier = courier;
  }

  getCourier() {
    return this.courier;
  }

  setAvailableCourier(availableCourier) {
    this.availableCourier = availableCourier;
  }

  getAvailableCourier() {
    return this.availableCourier;
  }

  setAvailableCourierDates(availableCourierDates) {
    this.availableCourierDates = availableCourierDates;
  }

  getAvailableCourierDates() {
    return this.availableCourierDates;
  }

  setLabel(label) {
    this.label = label;
    this.labelChange.emit(this.label);
  }

  getLabel() {
    return this.label;
  }

  getBypassData(val) {
    if (val) {
      return this.sanitizer.bypassSecurityTrustHtml(val);
    }

    return null;
  }

  setBrandName(value) {
    this.brandName = value;
  }

  getBrandName() {
    return this.brandName;
  }

  setModelName(value) {
    this.modelName = value;
  }

  getModelName() {
    return this.modelName;
  }

  setTopHeight(value) {
    this.topHeight = value;
  }

  getTopHeight() {
    return this.topHeight;
  }

  createPageContent(content: any): PageContent {
    const newContent = new PageContent();
    newContent.secondTabFillMandatoryFields = content.secondTabFillMandatoryFields;
    newContent.secondTabTitle = this.getBypassData(content.secondTabTitle);
    newContent.secondTabValidationMessage = this.getBypassData(content.secondTabValidationMessage);
    newContent.thirdTabAddress = content.thirdTabAddress;
    newContent.thirdTabAddressDescription = content.thirdTabAddressDescription;
    newContent.thirdTabCity = content.thirdTabCity;
    newContent.thirdTabDistrict = content.thirdTabDistrict;
    newContent.thirdTabTown = content.thirdTabTown;
    newContent.thirdTabEmailDescription = content.thirdTabEmailDescription;
    newContent.thirdTabEmail = content.thirdTabEmail;
    newContent.thirdTabEnterAddress = content.thirdTabEnterAddress;
    newContent.thirdTabEnterEmail = content.thirdTabEnterEmail;
    newContent.thirdTabEnterGsm = content.thirdTabEnterGsm;
    newContent.thirdTabEnterIdentityNumber = content.thirdTabEnterIdentityNumber;
    newContent.thirdTabEnterName = content.thirdTabEnterName;
    newContent.thirdTabEnterSurname = content.thirdTabEnterSurname;
    newContent.thirdTabEnterYearOfBirth = content.thirdTabEnterYearOfBirth;
    newContent.thirdTabGsm = content.thirdTabGsm;
    newContent.thirdTabIdentityNumber = content.thirdTabIdentityNumber;
    newContent.thirdTabName = content.thirdTabName;
    newContent.thirdTabSelectCity = content.thirdTabSelectCity;
    newContent.thirdTabSelectDistrict = content.thirdTabSelectDistrict;
    newContent.thirdTabSelectTown = content.thirdTabSelectTown;
    newContent.thirdTabSurname = content.thirdTabSurname;
    newContent.thirdTabIBAN = content.thirdTabIBAN;
    newContent.thirdTabEnterIBAN = content.thirdTabEnterIBAN;
    newContent.thirdTabIBANTooltip = content.thirdTabIBANTooltip;
    newContent.thirdTabOrderNumber = content.thirdTabOrderNumber;
    newContent.thirdTabEnterOrderNumber = content.thirdTabEnterOrderNumber;
    newContent.thirdTabOrderNumberTooltip = content.thirdTabOrderNumberTooltip;
    newContent.thirdTabTitle = this.getBypassData(content.thirdTabTitle);
    newContent.thirdTabDescription = this.getBypassData(content.thirdTabDescription);
    newContent.thirdTabYearOfBirth = content.thirdTabYearOfBirth;
    newContent.thirdTabCashbackOrderDescription = this.getBypassData(content.thirdTabCashbackOrderDescription);
    newContent.thirdTabCashbackOrderWarning = this.getBypassData(content.thirdTabCashbackOrderWarning);
    newContent.thirdTabCashbackMobileWarning = content.thirdTabCashbackMobileWarning;
    newContent.firstTabSelectBrand = content.firstTabSelectBrand;
    newContent.firstTabSelectModel = content.firstTabSelectModel;
    newContent.fourthTabTitle = this.getBypassData(content.fourthTabTitle);
    newContent.fourthTabDescription = this.getBypassData(content.fourthTabDescription);
    newContent.fourthTabSection1ProductInformation =
      this.getBypassData(content.fourthTabSection1ProductInformation);
    newContent.fourthTabSection1ProposalAmount = this.getBypassData(content.fourthTabSection1ProposalAmount);
    newContent.fourthTabSection1Text = this.getBypassData(content.fourthTabSection1Text);
    newContent.fourthTabSection3Title = this.getBypassData(content.fourthTabSection3Title);
    newContent.fourthTabSection3Text = this.getBypassData(content.fourthTabSection3Text);
    newContent.fourthTabHomeDeliverySelection = this.getBypassData(content.fourthTabHomeDeliverySelection);
    newContent.fourthTabCourierDeliverySelection = this.getBypassData(content.fourthTabCourierDeliverySelection);
    newContent.fourthTabCourierCompany = this.getBypassData(content.fourthTabCourierCompany);
    newContent.fourthTabCourierInfoText = this.getBypassData(content.fourthTabCourierInfoText);
    newContent.fourthTabFromWhichAddressDeliver = this.getBypassData(content.fourthTabFromWhichAddressDeliver);
    newContent.fourthTabChangeAddress = this.getBypassData(content.fourthTabChangeAddress);
    newContent.fourthTabWhenWillWeDeliver = this.getBypassData(content.fourthTabWhenWillWeDeliver);
    newContent.fourthTabCantUseHomeDelivery = this.getBypassData(content.fourthTabCantUseHomeDelivery);
    newContent.layoutAnythingToRenew = this.getBypassData(content.layoutAnythingToRenew);
    newContent.layoutApprove = this.getBypassData(content.layoutApprove);
    newContent.layoutHeader1 = this.getBypassData(content.layoutHeader1);
    newContent.layoutHeader2 = this.getBypassData(content.layoutHeader2);
    newContent.layoutHeader3 = this.getBypassData(content.layoutHeader3);
    newContent.layoutHeader4 = content.layoutHeader4 ? this.getBypassData(content.layoutHeader4) : null;
    newContent.layoutNextStep = this.getBypassData(content.layoutNextStep);
    newContent.layoutPreviousStep = this.getBypassData(content.layoutPreviousStep);
    newContent.layoutProcessDescription = this.getBypassData(content.layoutProcessDescription);
    newContent.layoutProcessStep1Description = this.getBypassData(content.layoutProcessStep1Description);
    newContent.layoutProcessStep1Title = this.getBypassData(content.layoutProcessStep1Title);
    newContent.layoutProcessStep2Description = this.getBypassData(content.layoutProcessStep2Description);
    newContent.layoutProcessStep2Title = this.getBypassData(content.layoutProcessStep2Title);
    newContent.layoutProcessStep3Description = this.getBypassData(content.layoutProcessStep3Description);
    newContent.layoutProcessStep3Title = this.getBypassData(content.layoutProcessStep3Title);
    newContent.layoutProcessTitle = this.getBypassData(content.layoutProcessTitle);
    newContent.layoutProposalAmount = this.getBypassData(content.layoutProposalAmount);
    newContent.layoutProposalWillBeDisplayed = this.getBypassData(content.layoutProposalWillBeDisplayed);
    newContent.layoutStep01 = content.layoutStep01;
    newContent.layoutStep02 = content.layoutStep02;
    newContent.layoutStep11 = content.layoutStep11;
    newContent.layoutStep12 = content.layoutStep12;
    newContent.layoutStep21 = content.layoutStep21;
    newContent.layoutStep22 = content.layoutStep22;
    newContent.layoutStep31 = content.layoutStep31;
    newContent.layoutStep32 = content.layoutStep32;
    newContent.layoutStep41 = content.layoutStep41;
    newContent.layoutStep42 = content.layoutStep42;
    newContent.layoutStep51 = content.layoutStep51;
    newContent.layoutStep52 = content.layoutStep52;
    newContent.fourthTabSection2CourierNumber = content.fourthTabSection2CourierNumber;
    newContent.fourthTabSection2Text = content.fourthTabSection2Text;
    newContent.fourthTabSection2TextHomeDelivery = content.fourthTabSection2TextHomeDelivery;
    newContent.mainPageContent1 = this.getBypassData(content.mainPageContent1);
    newContent.mainPageContent2 = this.getBypassData(content.mainPageContent2);
    newContent.secondTabDescription = this.getBypassData(content.secondTabDescription);
    newContent.fourthTabCompleted = this.getBypassData(content.fourthTabCompleted);
    newContent.buybackCategories = content.buybackCategories;
    newContent.cashbackCategories = content.cashbackCategories;
    newContent.selectionTabProposalAmount = content.selectionTabProposalAmount;
    newContent.selectionTabBuyback = content.selectionTabBuyback;
    newContent.selectionTabCashback = content.selectionTabCashback;
    newContent.selectionTabCashbackTooltip = content.selectionTabCashbackTooltip;
    newContent.selectionTabCashbackDescription = content.selectionTabCashbackDescription;
    newContent.selectionTabBuybackTooltip = content.selectionTabBuybackTooltip;
    newContent.layoutProcessMainTitle = content.layoutProcessMainTitle;
    newContent.layoutProcessSubtitleBuyback = content.layoutProcessSubtitleBuyback;
    newContent.layoutProcessSubtitleCashback = content.layoutProcessSubtitleCashback;
    newContent.layoutProcessDescriptionBuyback = this.getBypassData(content.layoutProcessDescriptionBuyback);
    newContent.layoutProcessBuyback = this.getBypassData(content.layoutProcessBuyback);
    newContent.layoutProcessDescriptionCashback = this.getBypassData(content.layoutProcessDescriptionCashback);
    newContent.layoutProcessCashback = this.getBypassData(content.layoutProcessCashback);
    newContent.layoutProcessFooter = this.getBypassData(content.layoutProcessFooter);
    return newContent;
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/right-side.service.ts